<script lang="ts">
    import CardPackModal from "../presentationals/modals/CardPackModal.svelte";
    import CardModal from "../presentationals/modals/CardModal.svelte";
    import SettingsModal from "../presentationals/modals/SettingsModal.svelte";

    export let details;
    export let manager;
</script>

{#if $details.type === 'cardPack'}
    <CardPackModal on:modalOpen cards={$details.data} manager={manager}/>
{/if}
{#if $details.type === 'card'}
    <CardModal cardData={$details.data} manager={manager}/>
{/if}